const SURFACE_KEYS = [
  "onEntityTagClick",
  "withAppliedCount",
  "small",
  "highlighted",
  "inline",
  "entityType",
  "entityId",
  "tagTypes",
  "tagsQueryTagTypes",
  "featureFlags",
  "editOnly",
  "onTagUpdated",
  "loading",
  "TagSelector",
  "onTagsLoaded",
  "isAssociationTag",
  "label",
  "bulkTagMode",
  "menuPlacement",
  "menuPortalTarget",
  "hideDropdown",
  "editButtonIcon",
  "icons",
  "editButtonLabel",
  "readOnly",
  "tagTypesConfig",
  "mt",
] as const;

export type SurfaceKey = (typeof SURFACE_KEYS)[number];

export const tagsEditorSurface = (
  props: Partial<Record<SurfaceKey, unknown>>
): Record<SurfaceKey, unknown> =>
  SURFACE_KEYS.reduce<Record<SurfaceKey, unknown>>(
    (surface, key) => {
      surface[key] = props[key];
      return surface;
    },
    {} as Record<SurfaceKey, unknown>
  );
